import { toast } from "react-toastify";
import { observable } from "mobx";
import { api } from "../../api";
import { ICstConfigSped, IEmpresa, IEntradaCFOP, IProdutoGenerico, ISaidaCFOP, ISpedEfd, newEmpresa, newICstConfigSped, newIEntradaCFOP, newISaidaCFOP, newISpedEfd } from "../../model";

export class _SpedEfdStore {
  obs = observable({
    selectedEmpresa: newEmpresa() as IEmpresa,
    sped: newISpedEfd() as ISpedEfd,
    cfop_saida: newISaidaCFOP() as ISaidaCFOP,
    cfop_entrada: newIEntradaCFOP() as IEntradaCFOP,
    cfop_entrada_estadual_especifico: [] as any,
    cfop_entrada_interestadual_especifico: [] as any,
    cfop_saida_estadual_especifico: [] as any,
    cfop_saida_interestadual_especifico: [] as any,
    config_id: "" as string,
    index_cfops: [] as any,
    index_csts: [] as any,
    open_select_empresa: false as boolean,
    cst: "selecione" as string,
    input_cfop_entrada: "" as string,
    input_cfop_saida: "" as string,
    input_cfop_saida_especifico: "" as string,
    input_cfop_entrada_especifico: "" as string,
    cfops_selecionados: "" as string,
    csts_selecionados: "" as string,
    cfop_saida_descricao: "" as string,
    cfop_entrada_descricao: "" as string,
    cfops_current: 1 as number,
    cfops_length: 0 as number,
    isEdit: false as boolean,
    tab_entrada_saida: "geral" as string,
    select_config_saidas_tab: "opcoes" as string,
    select_config_entradas_tab: "opcoes" as string,
    select_tab_geral: "produtos" as string,
    filter_produtos_sped: "" as string,
    index_produtos: [] as any,
    produtos_length: 0 as number,
    produtos_current: 1 as number,
    deletarProdutos: [] as any[],
    loading: false as boolean,
    loadingSelectAll: false as boolean,
    selectedEmpresaImport: newEmpresa() as IEmpresa,
    entrada_saida: "" as string,
    modelo: "selecione" as string,
    index_cfops_import: [] as any,
    generic_produtos: [] as IProdutoGenerico[],
    generic_produtos_all: [] as IProdutoGenerico[],
    generic_produtos_length: 0 as number,
    generic_produtos_filter: "" as string,
    generic_produtos_current: 1 as number,
    index_config_cst: newICstConfigSped() as ICstConfigSped,
    isEmpresa: false as boolean,
    loading_export: false as boolean,
    c176_validador: false as boolean

  })

  setDeletearItems(items: any) {
    this.obs.deletarProdutos.push(items);
  }

  setDeletarItemsList(items: any[]) {
    this.obs.deletarProdutos = items;
  }

  deleteByIdProdutosItems(id: string) {
    this.obs.deletarProdutos = this.obs.deletarProdutos.filter(value => value.id != id)
  }

  resetDeletarItems() {
    this.obs.deletarProdutos = [];
  }

  selectAllContestarLote() {
    this.resetDeletarItems();
    for (let i = 0; i < this.obs.index_produtos.length; i++) {
      let data = this.obs.index_produtos[i]
      this.obs.deletarProdutos.push(data)
    }
  }

  async handleBuscaCfopSaida(value: string) {

    let params = {
      cfop: value.replace(/\-/g, ""),
    }
    try {
      let resp = await api.post('/api/sped/cfop-saida/index', params)

      if (resp.data.descricao != null) {
        this.obs.cfop_saida_descricao = ""
        this.obs.cfop_saida.cfop_saida = value.replace(/\-/g, "")
        this.obs.cfop_saida_descricao = resp.data.descricao

      } else {
        this.obs.cfop_saida_descricao = ""
        toast.error('CFOP Inválido', {});
      }
    } catch (ex) { }
  }

  async handleBuscaCfopsEntrada(value: string) {

    let params = {
      cfop: value.replace(/\-/g, ""),
    }
    try {
      let resp = await api.post('/api/sped/cfop-entrada/index', params)

      if (resp.data.descricao != null) {
        this.obs.cfop_entrada_descricao = ""
        this.obs.cfop_entrada_descricao = resp.data.descricao

      } else {
        this.obs.cfop_entrada_descricao = ""
        this.obs.input_cfop_entrada = ""
        toast.error('CFOP Inválido', {});
      }
    } catch (ex) { }

  }


  async handleBuscaCfopEntrada(value: string) {

    let params = {
      cfop: value.replace(/\-/g, ""),
    }
    try {
      let resp = await api.post('/api/sped/cfop-entrada/index', params)

      if (resp.data.descricao != null) {
        this.obs.cfop_entrada_descricao = ""
        this.obs.cfop_entrada.cfop_entrada = value.replace(/\-/g, "")
        this.obs.cfop_entrada_descricao = resp.data.descricao

      } else {
        this.obs.cfop_entrada_descricao = ""
        toast.error('CFOP Inválido', {});
      }
    } catch (ex) { }

  }

  async handleBuscaCfopsSaida(value: string) {

    let params = {
      cfop: value.replace(/\-/g, ""),
    }
    try {
      let resp = await api.post('/api/sped/cfop-saida/index', params)

      if (resp.data.descricao != null) {
        this.obs.cfop_saida_descricao = ""
        this.obs.cfop_saida_descricao = resp.data.descricao

      } else {
        this.obs.cfop_saida_descricao = ""
        this.obs.input_cfop_saida = ""
        toast.error('CFOP Inválido', {});
      }
    } catch (ex) { }

  }

  async handleLoadCST() {
    try {
      let resp = await api.get('/api/sped/cst/index')

      if (resp.data) {
        this.obs.index_csts = []
        this.obs.index_csts = resp.data
      }
    } catch (ex) { }

  }

  async handleSaveCfop(params: any) {

    try {
      let resp = await api.post('/api/sped/cfop/create', params)

      if (resp.data.ok == true) {
        toast.success('CFOP criado com sucesso.', {});
      } else {
        toast.error('Erro ao criar CFOP.', {});
      }
    } catch (ex) { }

    await this.loadCfops(this.obs.tab_entrada_saida, 1, this.obs.config_id);
  }

  async handleUpdateCfop(params: any) {
    try {
      delete params["config_id"]

      let resp = await api.post('/api/sped/cfop/update', params)

      if (resp.data.ok == true) {
        toast.success('CFOP editado com sucesso.', {});
        await this.loadCfops(this.obs.tab_entrada_saida, 1, this.obs.config_id);
      } else {
        toast.error('Erro ao editar CFOP.', {});
      }
    } catch (ex) { }

  }

  async loadCfops(tipo: string, page: number, config_id: string) {
    let params = {
      "limit": 5,
      "tipo": tipo,
      "page": page,
      "id": config_id
    }
    try {
      let resp = await api.post('/api/sped/cfops/index', params)

      this.obs.index_cfops = []
      this.obs.cfops_length = 0

      if (resp.data.itens.length > 0) {
        this.obs.index_cfops = resp.data.itens
        this.obs.cfops_length = resp.data.count
      }

    } catch (ex) { }

  }

  async loadSped(cnpj: string, tipo: string, modelo: string) {
    let params = {
      cnpj: cnpj,
      tipo: tipo,
      modelo: modelo
    }
    try {
      let resp = await api.post('/api/sped/config/index', params)

      if (resp.data.length > 0) {
        this.obs.sped = newISpedEfd()
        this.obs.config_id = resp.data[0].id
        this.obs.sped = resp.data[0]

      } else {
        let data = {
          cnpj: cnpj,
          tipo: tipo,
          modelo: modelo
        }

        await this.handleSaveSped(data)
        await this.loadSped(cnpj, tipo, modelo)
      }
    } catch (ex) { }

  }

  async handleSaveSped(params: any) {
    try {
      let resp = await api.post('/api/sped/config/create', params)

      if (resp.data.ok == true) {
        toast.success('Configuração atualizada.', {});
      } else {
        toast.error('Erro ao realizar configuração.', {});
      }
    } catch (ex) { }

  }

  async handleDeleteCfop(id: string, codigo: string, cfops: any) {
    let params = {
      codigo: codigo,
      id: id,
      cfops: cfops
    }
    try {
      let resp = await api.post(`/api/sped/cfop/delete`, params)

      if (resp.data == "ok") {
        toast.success('CFOP deletado com sucesso!.', {});

        await this.loadCfops(this.obs.tab_entrada_saida, 1, this.obs.config_id)

      } else {
        toast.error('Erro ao Deletar CFOP.', {});
      }
    } catch (ex) { }

  }

  async cfopsCadastrados(tipo: string, config_id: string) {
    let params = {
      "tipo": tipo,
      "id": config_id
    }
    try {
      let resp = await api.post('/api/sped/cfops-all/index', params)

      return resp.data.items
    } catch (ex) {
      return []
    }

  }


  async handleBuscaProdutos(cnpj: string, page: number, text: string) {
    this.resetDeletarItems();

    let params = {
      cnpj: cnpj,
      page: page,
      limit: 100,
      text: text
    }
    try {
      let resp = await api.post('/api/sped/produtos/index', params)

      this.obs.index_produtos = []
      this.obs.produtos_length = 0

      if (resp.data.itens.length > 0) {
        this.obs.index_produtos = resp.data.itens
        this.obs.produtos_length = resp.data.count
      }
    } catch (ex) { }

  }

  async handleDeleteProdutos() {
    this.obs.loading = true
    this.obs.loadingSelectAll = true;
    try {
      let resp = await api.post('/api/sped/produtos/delete', { produtos: this.obs.deletarProdutos })

      if (resp.data == "ok") {
        toast.success(`Produtos Deletados!`, {});
        await this.handleBuscaProdutos(this.obs.selectedEmpresa.cnpj, 1, this.obs.filter_produtos_sped)
      }
    } catch (ex) { }

    this.obs.loading = false
    this.obs.loadingSelectAll = false;
  }

  async handleBuscaProdutosAll(cnpj: string, text: string) {
    this.resetDeletarItems();
    this.obs.loadingSelectAll = true;

    let total_tmp_arr: number = 1

    for (let i = 1; total_tmp_arr > 0; i++) {
      let params = {
        cnpj: cnpj,
        text: text,
        page: i,
        limit: 500,
      };

      let resp = await api.post('/api/sped/produtos/index', params)

      total_tmp_arr = resp.data.length

      this.obs.deletarProdutos = [...this.obs.deletarProdutos, ...resp.data.itens.map(values => {
        values.id = values._id || values.id
        return values
      })]
    }

    this.obs.loadingSelectAll = false;
  }

  async handleSaveCfopProduto(params: any) {

    try {
      let resp = await api.post('/api/sped/produtos/cfop', params)

      if (resp.data.ok == true) {
        toast.success('CFOP incluido com sucesso.', {});

        await this.handleBuscaProdutos(this.obs.selectedEmpresa.cnpj, 1, this.obs.filter_produtos_sped)
      } else {
        toast.error('Erro ao incluir CFOP.', {});
      }
    } catch (ex) { }

  }

  async loadSpedImport(cnpj: string, tipo: string, modelo: string) {
    let params = {
      cnpj: cnpj,
      tipo: tipo,
      modelo: modelo
    }
    try {
      let resp = await api.post('/api/sped/config/index', params)

      if (resp.data.length > 0) {
        return resp.data[0].id
      } else {
        return ""
      }
    } catch (ex) {
      return ""
    }

  }

  async loadCfopsImport(config_id: string) {
    let params = {
      "id": config_id
    }
    try {
      let resp = await api.post('/api/sped/cfops-import/index', params)

      this.obs.index_cfops_import = []
      this.obs.index_cfops_import = resp.data
    } catch (ex) { }

  }

  async saveCfopsImport(params: string, entrada_saida: string) {
    try {
      let resp = await api.post('/api/sped/cfops-import/create', { dados: params, tipo: entrada_saida })

      if (resp.data.ok) {
        toast.success('Importação realizada com sucesso!', {});
        await this.loadCfops(this.obs.tab_entrada_saida, 1, this.obs.config_id);
      } else {
        toast.error('Erro ao realizar Importação.', {});
      }
    } catch (ex) { }

  }

  async deletarCFOPS(id: string) {
    try {
      let resp = await api.post('/api/sped/produtos/cfop/delete', { id: id })

      if (resp.data.ok) {
        toast.success('Exclusão realizada com sucesso!', {});
        await this.handleBuscaProdutos(this.obs.selectedEmpresa.cnpj, 1, this.obs.filter_produtos_sped)
      } else {
        toast.error('Erro ao realizar Exclusão.', {});
      }
    } catch (ex) { }

  }

  async handleBuscaProdutosGenericos(cnpj: string, page: number, text: string) {

    let params = {
      cnpj: cnpj,
      page: page,
      limit: 10,
      text: text
    }
    try {
      let resp = await api.post('/api/sped/produtos/generic/index', params)

      this.obs.generic_produtos_length = 0
      this.obs.generic_produtos = []

      if (resp.data.itens.length > 0) {
        this.obs.generic_produtos = resp.data.itens
        this.obs.generic_produtos_length = resp.data.count
      }
    } catch (ex) { }

  }

  async handleCreateProdutoGenerico(params: any) {

    try {

      let resp = await api.post('/api/sped/produto/generic/create', params)

      if (resp.data.ok == true) {
        toast.success('Produto Genérico criado com sucesso.', {});

        await this.handleBuscaProdutos(this.obs.selectedEmpresa.cnpj, SpedEfdStore.obs.produtos_current, this.obs.filter_produtos_sped)
      } else {
        toast.error('Erro ao criar Produto Genérico.', {});
      }
    } catch { }
  }

  async handleUpdateProdutoGenerico(params: any) {

    try {

      let resp = await api.post('/api/sped/produto/generic/update', params)

      if (resp.data.ok == true) {
        toast.success('Produto Genérico atualizado com sucesso.', {});

        await this.handleBuscaProdutosGenericos(this.obs.selectedEmpresa.cnpj, 1, this.obs.filter_produtos_sped)
      } else {
        toast.error('Erro ao atualizar Produto Genérico.', {});
      }
    } catch { }
  }

  async handleVincularGenerico(params: any) {

    try {

      let resp = await api.post('/api/sped/produto/vincular', params)

      if (resp.data.ok == true) {
        toast.success('Produto vinculado com sucesso.', {});

        await this.handleBuscaProdutos(this.obs.selectedEmpresa.cnpj, SpedEfdStore.obs.produtos_current, this.obs.filter_produtos_sped)
      } else {
        toast.error('Erro ao vincular Produto.', {});
      }
    } catch { }
  }

  async handleBuscaProdutosGenericosAll(cnpj: string) {

    let params = {
      cnpj: cnpj,
    }
    try {

      let resp = await api.post('/api/sped/produtos/generic/index/all', params)

      if (resp.data) {
        this.obs.generic_produtos_all = []
        this.obs.generic_produtos_all = resp.data
      }
    } catch { }
  }

  async handleDesvincularGenerico(produto: any) {
    try {

      let resp = await api.post('/api/sped/produto/desvincular', { produto: produto })

      if (resp.data.ok == true) {
        toast.success('Produto desvinculado com sucesso.', {});

      } else {
        toast.error('Erro ao desvincular Produto.', {});
      }
    } catch { }
  }

  async handleDeleteProdutoGenerico(id: string, produtos: any) {
    try {
      let resp = await api.post('/api/sped/produto/generic/delete', { id: id, produtos: produtos })

      if (resp.data.ok == true) {
        toast.success('Produto Genérico deletado com sucesso.', {});

        await this.handleBuscaProdutosGenericos(this.obs.selectedEmpresa.cnpj, 1, this.obs.filter_produtos_sped)
      } else {
        toast.error('Erro ao deletar Produto Genérico.', {});
      }
    } catch { }
  }

  async loadCsts(config_id: string) {
    let params = {
      "id": config_id
    }
    try {
      let resp = await api.post('/api/sped/csts/index', params)

      this.obs.index_config_cst = newICstConfigSped()
      this.obs.index_config_cst = resp.data
    } catch { }
  }

  async handleSaveCST(params: any) {
    try {
      let resp = await api.post('/api/sped/csts/update', params)

      if (resp.data.ok) {
        SpedEfdStore.loadCsts(SpedEfdStore.obs.config_id);
      }
    } catch { }

  }

  async handleSaveEditProduto(params: any) {
    try {
      let resp = await api.post('/api/sped/produto/update', params)

      if (resp.data.ok == true) {
        toast.success('Produto atualizado com sucesso.', {});

        await this.handleBuscaProdutos(this.obs.selectedEmpresa.cnpj, 1, this.obs.filter_produtos_sped)
      } else {
        toast.error('Erro ao atualizar Produto.', {});
      }
    } catch { }

  }

  async exportProdutos(cnpj: string) {
    try {
      this.obs.loading_export = true

      let params = { "cnpj": cnpj }

      let resp = await api.post("/api/sped/produtos/export", params);

      if (resp.data.ok) {
        const linkSource = `data:application/xlsx;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = "export_produtos.xlsx";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        toast.warning('Não foram encontrados resultados.', {});
      }
    } catch (ex) {
      toast.error("Erro ao exportar Produtos, tente novamente mais tarde!", {});
    }
    this.obs.loading_export = false
  }

}

export const SpedEfdStore = new _SpedEfdStore();